import React, { FC } from 'react'
import { gridConfigIE, InterfaceElementModel } from 'Pages/interfaceElement'
import { GridRow, OpenedComponentProps, RenderGridRowProps } from 'LibNeo'
import { CustomColumns } from './CustomColumns'
import { SubGridWrapper } from './styled'

export const OpenedComponent: FC<OpenedComponentProps<InterfaceElementModel>> = ({
	item,
}): JSX.Element => {
	const data = [].concat(item, item?.children.slice(0))
	return (
		<div>
			<SubGridWrapper
				getItems={null}
				data={data}
				total={0}
				renderGridRow={(props: RenderGridRowProps<InterfaceElementModel>) => (
					<GridRow
						columns={gridConfigIE.columns}
						CustomColumnsComponent={CustomColumns}
						{...props}
					/>
				)}
				renderGridHeader={() => null}
			/>
		</div>
	)
}
